import React, { ReactElement, useEffect, useState } from 'react'
import { Upload, Button, Form, Tooltip, message } from 'antd'
import recycle from 'assets/images/icons/recycle.svg'
import './index.scss'
import {
  RemoveIco,
  TabsInfoIco,
  UploadIcon,
} from '../../../modules/CustomIcons'
import SuccessOrErrorModal from 'components/SuccessOrErrorModal'
import WarningModal from 'components/WarningModal'
import file from 'assets/images/icons/file.svg'
import { useTranslation } from 'react-i18next'
import { getAllFilesOrderPdfByName } from '../../services/transfers'
import { deleteFileById } from '../../services/Transfers/Files'
import { log } from 'console'

const FileUpload = (props: any) => {
  const { t } = useTranslation()
  const [fileList, setFileList] = useState<any[]>([])
  const [FileSend, setFileSend] = useState<any[]>([])
  const [editPdfList, setList] = useState<any[]>([])
  const [visibleErrorMessage, setVisibleErrorMessage] = useState<boolean>(false)
  const [visibleErrorMessageLimit, setVisibleErrorMessageLimit] =
    useState<boolean>(false)

  useEffect(() => {
    setList(props.editFileList)
  }, [])
useEffect(() => {
  if (props.tempFileList?.length) {    
    const mappedFiles = props.tempFileList.map((f: any, index: number) => {
      const isFile = f instanceof File;

      return {
        uid: f.uid || String(index),
        name: f.name,
        status: 'done',
        size: f.size,
        type: f.type || 'application/pdf',
        originFileObj: isFile ? f : f.originFileObj || undefined,
      };
    });
    setFileList(mappedFiles);
  }
}, [props.tempFileList]);



  // console.log("aaaaaaaa",props.accept);

  const propsUpload = {
    multiple: props.multiple || false,
    accept: props.accept,
    disabled: props.disabled || false,
    showUploadList: {
      showDownloadIcon: false,
      removeIcon : <img src={recycle}/>,
      showPreviewIcon: false,
    },
    onRemove: (file: any) => {
      const index = fileList.indexOf(file)
      const newFileList: any = fileList.slice()
      newFileList.splice(index, 1)
      return setFileList(newFileList)
    },
    beforeUpload: (file: any) => {
      let sum = fileList.reduce(function (prev, current) {
        return prev + +current.size
      }, 0)
      if (
        (props.fileLimit !== undefined &&
          props.fileLimit === fileList.length) ||
        (props.checkSize && sum + file.size > 100000000) ||
        file.size > 10000000
      ) {
        setVisibleErrorMessageLimit(true)
      } else if (
        !props.accept.includes(file.type) ||
        props.accept !== file.type
      ) {
        setVisibleErrorMessage(true)
      } else {
        setFileList([...fileList, file])
      }
      return false
    },
    onChange(info: any) {
      let sum = info?.fileList?.reduce(function (prev, current) {
        return prev + +current.size
      }, 0)
      let warning = false
      info?.fileList?.forEach((file) => {
        if (!props.accept.includes(file.type) || props.accept !== file.type) {
          warning = true
        }
      })
      if (
        (props.fileLimit !== undefined &&
          props.fileLimit === info?.fileList?.length) ||
        (props.checkSize && sum > 100000000) ||
        warning
      ) {
        const list = { fileList: fileList, file: fileList[fileList.length - 1] }
        if (props.onChange) {
          props.onChange(list)
        }
      } else {
        if (props.onChange) {
          props.onChange(info)
        }
      }

      const listFiles = info.fileList.slice(-3)
      const newArrayFiles = listFiles.map((file: any) =>
        file.originFileObj ? file.originFileObj : file
      )
      const anAsyncFunction = async (item: any) => {
        return item
        // return item.type !== 'application/pdf' ? props.convertBase64(item) : item;
      }

      const getData = async () => {
        return Promise.all(
          newArrayFiles.map((item: any) => anAsyncFunction(item))
        )
      }
      getData().then((data) => {
        setFileSend(data)
      })

      const list_items = document.getElementsByClassName(
        'ant-upload-list-item-name'
      )

      for (let index = 0; index < list_items.length; index++) {
        let item = list_items[index]
        let file = info.fileList[index]
        
        item.addEventListener('click', function (e) {
          if (!e.handle) {
            e.handle = true

            let blob = new Blob([file.originFileObj], {
              type: 'application/octetstream',
            })

            let fileName = file.name

            let isIE = false || !!document?.documentMode
            if (isIE) {
              window.navigator?.msSaveBlob(blob, fileName)
            } else {
              let url = window.URL || window.webkitURL
              let link = url.createObjectURL(blob)
              let a = document.createElement('a')
              a.setAttribute('download', fileName)
              a.setAttribute('href', link)
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)
            }
          }
        })
      }
    },
    fileList: fileList,
  } 
  // console.log("fal",fileList);
  
  // const deletePdfFile = async (fileId: any) => {
  //   deleteFileById()
  // }
  
  const handleGetPdfAdditional = async (ibanRef: any, filename: any) => {
    const data = await getAllFilesOrderPdfByName(ibanRef, filename)
    // setFileData(data)
    data?.data.fileDetailsList.map(function (item, i) {
      const downloadLink = document.createElement('a')
      downloadLink.href = item.fileBase64
      downloadLink.download = filename
      downloadLink.click()
    })
  }

  const onReset = () => {
    setFileList([])
  }
  
  return (
    <>
      <Form.Item
        name={props.name}
        label={props.labelItem}
        labelCol={props.labelCol}
        className={
          props.greenUpload
            ? `green-upload ${props.className}`
            : props.className
        }
        wrapperCol={props.wrapperCol}
        onReset={onReset}
        // className={props.className}
        rules={[{ required: props.required || false }]}
        style={props.style}
        tooltip={{
          title: t('newTransfer.PDFDescription'),
          icon: (
            <Button
              type={'ghost'}
              className={'transparent'}
              icon={<TabsInfoIco />}
            />
          ),
        }}
      >
        <Upload
          {...(props.propsFileUpload ? props.propsFileUpload : propsUpload)}
          fileList={props.fileListPdf || fileList}
          listType="picture"
          disabled={props?.disabled ?? false}
        >
          {fileList.length == 0 && props.editFileList?.length < 1 && (
            <Button icon={props.greenUpload && <UploadIcon />}>
              {props.placeholder}
            </Button>
          )}

          <img
            src={file}
            className={`file-img ${props.disabled ? 'disabled--pdfBtn' : ''}`}
          />
          <div />
        </Upload>
        {props.editFileList?.length > 0 &&
          props.editFileList?.map((line: any, index: any) => {
            return (
              <div className={'flex'} key={index} style = {{position:"relative"}}>
                <a
                  className={
                    'table swift_table table_pdf modal_pdf ant-upload-list ant-upload-list-picture'
                  }
                  type={'button'}
                  style={{
                    textAlign: 'center',
                    color: '#015CD1',
                    alignItems: 'center',
                  }}
                  onClick={() =>
                    handleGetPdfAdditional(props.ibankRef, line.fileName)
                  }
                >
                  <p
                    style={{
                      margin: '10px 20px',
                      fontSize: '12px',
                      overflow: 'hidden',
                      textAlign:"start",
                      width:"85%"
                    }}
                  >
                    {line.fileName}
                  </p>
                </a>
                {props.editOrRepeat ? (
                  <Button
                    className={'picture button-remove'}
                    onClick={() => props.removeFile(index, true)}
                    // icon={}
                  ><RemoveIco /></Button>
                ) : (
                  <Button
                    className={'picture button-remove'}
                    onClick={() => props.removeFile(index, false)}
                    // icon={}
                  ><RemoveIco /></Button>
                )}
              </div>
            )
          })}
        {props.greenUpload && fileList.length !== 0 && (
          <button
            onClick={props.handleUpload}
            className="file-upload_btn green--btn"
          >
            {t('salary.upload')}
          </button>
        )}
      </Form.Item>

      {props.salary ? (
        <WarningModal
          title={t('common.error')}
          modalType={'error'}
          modalText={t('notification.onlyPDFType')}
          visibleModal={visibleErrorMessage}
          onCancel={() => {
            setVisibleErrorMessage(() => false)
          }}
          onOk={() => {
            setVisibleErrorMessage(() => false)
          }}
        />
      ) : (
        <SuccessOrErrorModal
          modalTitle={t('common.error')}
          modalType={'error'}
          modalText={t('notification.onlyPDFType')}
          visible={visibleErrorMessage}
          onClose={() => {
            setVisibleErrorMessage((old_status) => false)
          }}
        />
      )}
      <SuccessOrErrorModal
        modalTitle={t('common.attention')}
        modalType={'error'}
        modalText={t('notification.totalSizeLimit')}
        visible={visibleErrorMessageLimit}
        onClose={() => {
          setVisibleErrorMessageLimit((old_status) => false)
        }}
      />
    </>
  )
}

export default FileUpload
